import { EChartsOption } from 'echarts';
import { defaultYAxisConfig } from '../constants';
import { YAXisOption } from 'echarts/types/dist/shared';

export function createPercentageYAxis(): EChartsOption['yAxis'] {
  return {
    ...defaultYAxisConfig,
    axisLabel: {
      ...defaultYAxisConfig.axisLabel,
      formatter: (value) => `${value}%`,
    },
    splitNumber: 5,
    min: 0,
    interval: 25,
    max: 100,
  } as YAXisOption;
}

export function generateMonthYearXAxisNames(data?: { YEAR: number, MONTH: number }[]): { value: string }[] {
  return generateDayMonthYearXAxisNames(data?.map((item) => ({ DAY: 1, MONTH: item.MONTH, YEAR: item.YEAR })));
}

export function generateDayMonthYearXAxisNames(data?: { DAY: number, YEAR: number, MONTH: number }[]): { value: string }[] {
  const axis: { value: string }[] = [];

  for (const item of (data ?? [])) {
    const date = new Date(item.YEAR, item.MONTH - 1, item.DAY);
    axis.push({
      value: date.toISOString(),
    });
  }

  return axis;
}
